import appHero from '../assets/images/services/hero/app-hero.png'
import cloudHero from '../assets/images/services/hero/cloud-hero.png'
import dataHero from '../assets/images/services/hero/data-hero.png'
import securityHero from '../assets/images/services/hero/security-hero.png'
import pillarApp from '../assets/images/services/hero/hero-services-icon.svg'
import pillarDataAi from '../assets/images/services/hero/hero-services-icon-2.svg'
import pillarCloud from '../assets/images/services/hero/hero-services-icon-3.svg'
import pillarCyber from '../assets/images/services/hero/hero-services-icon-4.svg'

/** Intrinsic PNG sizes for {@link ServicePageHero} (CLS). */
export const SERVICE_HERO_ASSETS = {
  app: { src: appHero, width: 482, height: 380 },
  cloud: { src: cloudHero, width: 487, height: 526 },
  data: { src: dataHero, width: 528, height: 351 },
  security: { src: securityHero, width: 480, height: 396 },
}

/** Inline hero pillar icons (order: app, data/AI, cloud, cyber). */
export const SERVICE_PAGE_PILLAR_ICONS = {
  app: { src: pillarApp, width: 52 },
  data: { src: pillarDataAi, width: 40 },
  cloud: { src: pillarCloud, width: 40 },
  security: { src: pillarCyber, width: 40 },
}
